module.exports = __webpack_public_path__ + "img/male-black-18dp.1c11c2f2.svg";